const C = require("../constants");
const initial_data = {open: false, section:{id:null, name:'', branch_office:''}};

function SectionDialogReducer(state = initial_data, action) {
    switch (action.type) {
        case C.SECTION_DIALOG:
            return action.data;
        default:
            return state;
    }
}

export default SectionDialogReducer;


// WEBPACK FOOTER //
// ./src/reducers/SectionDialogReducer.js